export default "<p>configuracion-cuotas works!</p>\r\n";